function CloseSvg({fill="#0E0F0F", height = 16, width= 16}) {
    return (
        <svg width={width} height={height} viewBox="0 0 16 16" fill={fill} xmlns="http://www.w3.org/2000/svg">
            <g id="cross">
                <path id="Union" fill-rule="evenodd" clip-rule="evenodd" d="M3.23268 2.10033C2.92026 1.78791 2.41373 1.78791 2.10131 2.10033C1.78889 2.41275 1.78889 2.91928 2.10131 3.2317L6.86915 7.99954L2.1015 12.7672C1.78908 13.0796 1.78908 13.5861 2.1015 13.8986C2.41392 14.211 2.92045 14.211 3.23287 13.8986L8.00052 9.13091L12.768 13.8984C13.0804 14.2108 13.5869 14.2108 13.8993 13.8984C14.2118 13.5859 14.2118 13.0794 13.8993 12.767L9.13189 7.99954L13.8995 3.2319C14.212 2.91948 14.212 2.41294 13.8995 2.10053C13.5871 1.78811 13.0806 1.78811 12.7682 2.10053L8.00052 6.86817L3.23268 2.10033Z" fill={fill}/>
            </g>
        </svg>

    )
};

export default CloseSvg;